import React from 'react';

// Styles in home.css
export const ArticlesHome = ({ description, avatar, title, subTitle }) => {
    return (
        <article className='article__home'>
            <p>{description}</p>
            <h3><strong>{title}</strong> <br /> {subTitle}</h3>
        </article>
    );
};

// Styles in travel.css
const Articles = ({ icon, title, description }) => {
    return (
        <article>
            <img src={icon} alt="article_icon" />
            <h6>{title}</h6>
            <p>{description}</p>
        </article>
    );
};

export default Articles;